import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export interface Integration {
  name: string
  active: boolean
}

export async function getUserIntegrations(options?: AxiosRequestConfig) {
  const { data } = await usersApi.get<Integration[]>(
    apiRoutes.getUserIntegrations,
    options,
  )

  return data
}
